var BaseAudioEffector = /** @class */ (function () {
    function BaseAudioEffector(audioCtx, audioSource, logger) {
        this.using = false;
        this.effectorName = 'BaseAudio';
        this.audioCtx = audioCtx;
        this.audioSource = audioSource;
        this.logger = logger;
    }
    /**
     * 传入外部音效节点链接到当前节点，并且返回当前节点
     * @param node
     */
    BaseAudioEffector.prototype.connectBy = function (node) {
        if (!node) {
            return null;
        }
        return node;
    };
    /**
     * 断开音效节点，消除该效果
     */
    BaseAudioEffector.prototype.disconnect = function () {
        var _a;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.effectorName, " disconnect()"));
    };
    /**
     * 销毁该音效节点
     */
    BaseAudioEffector.prototype.destroy = function () {
        var _a;
        this.disconnect();
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.effectorName, " destroy()"));
        this.logger = null;
    };
    /**
     * 获取当前效果器名称
     */
    BaseAudioEffector.prototype.getEffectorName = function () {
        return this.effectorName;
    };
    /**
     * 设置预制音效参数
     */
    BaseAudioEffector.prototype.setPreConfigName = function (effectName) {
        var _a;
        if (effectName === this.currPreCfgName) {
            return;
        }
        this.currPreCfgName = effectName;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("BaseAudioEffector setPreConfigName(), currPreCfgName=".concat(effectName));
    };
    /**
     * 获取预制音效参数
     */
    BaseAudioEffector.prototype.getPreConfigName = function () {
        return this.currPreCfgName;
    };
    return BaseAudioEffector;
}());
export default BaseAudioEffector;
